module.exports = __webpack_public_path__ + "static/globe_bg_mobile-0a20e31e1d92dbe0887b70e322ce9d1d.jpg";